import { render } from "./아이디찾기.vue?vue&type=template&id=39e48994"
import script from "./아이디찾기.vue?vue&type=script&lang=js"
export * from "./아이디찾기.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__